module.exports = __webpack_public_path__ + "img/palette.bc81c82b.png";